import React from 'react';

interface FullPageLoaderProps {
  message?: string;
}

const FullPageLoader: React.FC<FullPageLoaderProps> = ({
  message = 'Carregando sua sessao...',
}) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4 text-text">
      <div className="flex flex-col items-center gap-4 rounded-2xl border border-border bg-surface px-8 py-6 shadow-calm">
        <div className="h-9 w-9 animate-spin motion-reduce:animate-none rounded-full border-4 border-border border-t-primary" />
        <p className="text-sm font-medium tracking-wide text-muted">{message}</p>
      </div>
    </div>
  );
};

export default FullPageLoader;